import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Cookies from 'vue-cookies'
import ElementUI, { FormItem } from 'element-ui'
// 修复：el-form-item 未设置 prop 却添加了 required 时，会触发“undefined is required”的误导性报错。
// 统一拦截：没有 prop 的表单项不参与校验。
const _formItemValidate = FormItem.methods.validate;
FormItem.methods.validate = function (trigger, callback) {
  if (!this.prop) {
    if (typeof callback === 'function') {
      callback();
    }
    return true;
  }
  return _formItemValidate.apply(this, arguments);
};
import QuillEditor from 'vue-quill-editor'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/font/iconfont.css'
import '@/fontchoose/iconfont.css'
import '@/style/overall.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import "../static/UE/ueditor.config.js";
import "../static/UE/ueditor.all.js";
import "../static/UE/lang/zh-cn/zh-cn.js";
import "../static/UE/ueditor.parse.min.js";
import common from '@/utils/common';
import axios from 'axios';

axios.interceptors.response.use(function (response) {
  return response;
}, (error) => {
  let status = error.response.status;
  if (status == 401) { // 登录过期，跳转到登录页面
    store.commit("tabs/removeAll");
    Cookies.remove("user");
    router.replace({
      name: "login"
    });
  }
})

Vue.use(ElementUI)
Vue.use(Cookies)
Vue.use(common)
Vue.use(QuillEditor)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js